import React from "react";
import noImage from "../../assets/no_image.jpeg";

export default function ItemGroupImageDisplay({ imageList = [] }) {
  // Safely get up to 5 images (main + 4 thumbnails)
  const images = [
    imageList[0]?.Picture_URL || noImage,
    imageList[1]?.Picture_URL || noImage,
    imageList[2]?.Picture_URL || noImage,
    imageList[3]?.Picture_URL || noImage,
    imageList[4]?.Picture_URL || noImage,
  ];

  // Main image is the first one (or fallback)
  const mainImage = images[0];

  return (
    <div className="w-full">
      {/* Main Image - larger and centered */}
      <div className="mb-5 flex justify-center">
        <div className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 max-w-md w-full">
          <img
            src={mainImage}
            alt="Main product image"
            className="w-full h-64 sm:h-72 lg:h-80 object-cover transition-transform duration-500 hover:scale-105"
            loading="lazy"
            onError={(e) => {
              e.target.src = noImage;
              e.target.alt = "Image not available";
            }}
          />
        </div>
      </div>

      {/* Thumbnails Grid - responsive, 2–5 columns depending on screen size */}
      {imageList.length > 1 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
          {images.slice(1).map((src, idx) => (
            <div
              key={idx}
              className="relative overflow-hidden rounded-lg shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer group"
            >
              <img
                src={src}
                alt={`Product thumbnail ${idx + 2}`}
                className="w-full h-20 sm:h-24 object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
                onError={(e) => {
                  e.target.src = noImage;
                  e.target.alt = "Thumbnail not available";
                }}
              />
              {/* Subtle overlay on hover */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
            </div>
          ))}
        </div>
      )}

      {/* Optional message when there are no extra images */}
      {imageList.length <= 1 && imageList.length > 0 && (
        <p className="text-center text-sm text-gray-500 mt-3 italic">
          Only main image available
        </p>
      )}
    </div>
  );
}